import { render } from "./NavItem.vue?vue&type=template&id=27b96ce6"
import script from "./NavItem.vue?vue&type=script&lang=js"
export * from "./NavItem.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ARCHIVOS\\PROYECCION SERVIDOR\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__